// extracted by css-extract-rspack-plugin
export default {"container":"PlanTypeSegmentedControl-module__container__QLgG2","segment":"PlanTypeSegmentedControl-module__segment__SsHrs"};